<template>
  <div class="layout-col">
    <div class="-wrapper -h-center -font-family-base -font-size-12">
      <g-dropdown
        id="dashboard-top-select-sales"
        class="-mr-2 -button-ui"
        style="width:180px; 4px;"
        variant="borderless"
        dropdownType="button"
        textClass="-border -bg-white -wrapper-raius"
        buttonSize="large"
        v-model="selectSaleUser" v-if="showSelectEmployee">
        <g-dropdown-item-wrap id="dashboard-top-select-sales-open">
          <input type="text" class="-input" @keyup="onKeyupSearchSalesText"
                 style="
                            width: 100%;
                            position: sticky;
                            border: 1px;
                            border-style: solid;
                            height: 32px;
                            display: -ms-inline-flexbox;
                            display: inline-flex;
                            -ms-flex-align: center;
                            align-items: center;
                            border-radius: 4px!important;
                            padding: 0 12px;
                            transition: border-color .3s linear;
                            max-width: 800px;
                            border-color: #d3d8e0!important;
                            z-index: 10000000;
                            top: 0;
                            background: #fff;">
          <g-dropdown-item v-show="searchSalesText === '' || item.employeeName.indexOf(searchSalesText) > -1" :key="item.salesId" :text="item.employeeName" :value="item" v-for="item in salesList" />
        </g-dropdown-item-wrap>
      </g-dropdown>
      <div class="-border -bg-white -wrapper-raius" v-if="showSelectEmployee || userAuth === AUTH_GROUP.BespinSales">
        <g-dropdown-wrap
          ref="refDropdown"
          style="border-radius: 4px; height: 32px;"
          :style="`min-width: ${multiSelectWidth}px`"
          :openItem.sync="showDropdown">
          <template>
            <div class="-wrapper-between -pl-2 v-center-">
              <div class="-wrapper-v-center">
                <template v-if="showDropdown">
                  <input
                    type="text"
                    placeholder="Search..."
                    class="-font-size-12 -color-gray-1 -width-100"
                    :value="searchText"
                    @keyup="onKeyupSearchText"/>
                </template>
                <template v-else>
                  <g-chip
                    class="-mr-2"
                    v-for="item in customerSelectTop"
                    :key="item.customerDeptCode"
                    :text="item.customerDeptName"
                    :value="item"
                    @remove="onRemoveItem"
                    modify />
                </template>
              </div>
              <div class="-wrapper-v-center" id="dashboard-top-show-top-customer">
                <span class="-color-blue-1 -mr-1">
                  {{moreCustomerSelectedCount}}
                </span>
                <g-button
                  variant="borderless"
                  size="large"
                  class="-mx-0"
                  icon-only
                  @click="onClickMultiSelect">
                  <g-icon :name="dropIcon" />
                </g-button>
              </div>
            </div>
          </template>
          <g-dropdown-item-wrap id="dashboard-top-select-customer">
            <template v-for="item in filterCustomerList">
              <div
                v-if="item.customerCode === 'ALL'"
                :key="`_all_${item.customerDeptCode}`"
                class="-wrapper -px-2 -py-2 v-center">
                <input
                  type="checkbox"
                  class="-check"
                  value="ALL"
                  id="CHECKBOX_ALL"
                  :checked="item.checked"
                  @change="onClickAllChecked">
                <label for="CHECKBOX_ALL"><em class="-label">{{ $t('pages_dashboard_select_top.select_all') }}</em></label>
              </div>
              <g-checkbox
                v-if="item.customerCode !== 'ALL'"
                :key="item.customerDeptCode"
                :text="item.customerDeptName"
                :value="item.customerDeptCode"
                :checked="item.checked"
                @change="onChangeCustomer"
                class="-px-2 -py-2"/>
            </template>
          </g-dropdown-item-wrap>
        </g-dropdown-wrap>
      </div>
      <g-button id="dashboard-top-confirm-btn" variant="primary" class="-ml-2" @click="onClickSend" v-if="showSelectEmployee || userAuth === AUTH_GROUP.BespinSales">
        {{ $t('pages_dashboard_select_top.button') }}
      </g-button>
    </div>
  </div>
</template>

<script>

import {mapActions, mapGetters} from "vuex";
import {AUTH_GROUP} from "@/constants/constants";
import moment from "moment";
import {cloneDeep} from 'loadsh'

export default {
  data () {
    return {
      param: {},
      showDropdown: false,
      selectSaleUser: {},
      showSelectEmployee: false,
      userAuth : '',
      AUTH_GROUP : AUTH_GROUP,
      multiSelectWidth: 320,
      searchText: '',
      searchSalesText: '',
      cloneCustomerList: []
    }
  },
  computed: {
    ...mapGetters('dashboard', ['salesList', 'billMonth', 'productsMonth', 'customerList', 'contractTop', 'productsTop']),
    ...mapGetters('user', ['userInfo']),
    filterCustomerList () {
      if (this.searchText.trim() === '') {
        return this.cloneCustomerList
      }

      return this.cloneCustomerList.filter(item => item.customerDeptName.toUpperCase().indexOf(this.searchText.toUpperCase().trim()) !== -1)
    },
    dropIcon () {
      return this.showDropdown ? 'arrow_drop_up' : 'arrow_drop_down'
    },
    customerListNotInAll() {
      return this.cloneCustomerList.filter(item => item.customerDeptCode !== 'ALL' )
    },
    customerSelectTop () {
      const checked = this.customerListNotInAll.filter(item => item.checked)
      if (checked.length > 3) {
        return [0, 1, 2].map(idx => checked[idx])
      }
      return checked
    },
    moreCustomerSelectedCount () {
      if (!this.showDropdown) {
        let count = this.customerListNotInAll.filter(item => item.checked).length
        if (count > 3) {
          return `외 ${count - 3} 개`
        }
      }
      return ''
    }
  },
  methods: {
    ...mapActions('dashboard', ['getCustomersSales', 'getBillChartData', 'setBillMonth', 'getCustomers', 'getProductChartData', 'getBeforeMonthUsedAmount', 'selectBeforeMonthContractTop', 'selectBeforeMonthProductsTop', 'selectServiceRequestStatus']),
    getCustomerInfo (customerDeptCode) {
      return this.cloneCustomerList.find(item => item.customerDeptCode === customerDeptCode)
    },
    onKeyupSearchText (e) {
      this.searchText = e.target.value
    },
    onKeyupSearchSalesText(e){
      this.searchSalesText = e.target.value
    },
    isChecked (checkboxItem) {
      // return this.multiSelected.filter(item => item.customerDeptCode === checkboxItem.customerDeptCode).length > 0
      return checkboxItem.checked
    },
    checkClick(item){
      this.multiSelected.forEach(function (obj){
        if(item.customerDeptCode === 'ALL'){
          obj.checked = !item.checked
        }
      })
    },
    onRemoveItem (value) {
      const customer = this.getCustomerInfo(value.customerDeptCode)
      if (customer) {
        customer.checked = false
      }
      const customerDepthCodeAll = this.getCustomerInfo('ALL')
      if (customerDepthCodeAll && customerDepthCodeAll.checked) {
        customerDepthCodeAll.checked = false
      }
    },
    onClickMultiSelect (e) {
      if (this.showDropdown) {
        this.multiSelectWidth = 320
        setTimeout(() => {
          this.searchText = ''
        }, 100)
      } else {
        this.multiSelectWidth = this.$refs.refDropdown.$el.getBoundingClientRect().width
      }
      this.showDropdown = !this.showDropdown
    },
    onClickSend () {
      this.$showSpinner(true)
      this.onChangeData()
      this.getBillChartData(this.param)
      this.getProductChartData(this.param)
      this.getBeforeMonthUsedAmount(this.param)
      this.selectBeforeMonthContractTop(this.param)
      this.selectBeforeMonthProductsTop(this.param)
      this.selectServiceRequestStatus(this.param)
      this.$showSpinner(false)
    },
    onClickAllChecked () {
      const customerDepthCodeAll = this.getCustomerInfo('ALL')
      if (customerDepthCodeAll) {
        customerDepthCodeAll.checked = !customerDepthCodeAll.checked
        this.cloneCustomerList.forEach(item => {
          item.checked = customerDepthCodeAll.checked
        })
      }
    },
    onChangeCustomer (e) {
      this.$showSpinner(true)
      const customer = this.getCustomerInfo(e.target.value)
      const customerDepthCodeAll = this.getCustomerInfo('ALL')
      if (customer) {
        customer.checked = e.target.checked
        if (!customer.checked) {
          if (customerDepthCodeAll && customerDepthCodeAll.checked) {
            customerDepthCodeAll.checked = false
          }
        } else {
          if (this.customerListNotInAll.filter(item => !item.checked).length > 0) {
            customerDepthCodeAll.checked = false
          } else {
            customerDepthCodeAll.checked = true
          }
        }
      }
      this.$showSpinner(false)
    },
    onChangeData () {
      this.param.customerDepts = this.cloneCustomerList
    }
  },
  watch: {
    selectSaleUser (select) {
      if(select != undefined){
        if(select.salesId != 'undefined' && select.salesId != ''){
          this.getCustomers(select.salesId)
          this.param.empNo = select.costCenterCode
        }
        if(select.employeeName == 'ALL'){
          this.$showSpinner(true)
          this.getCustomers('null')
          this.param.empNo = ''
        }
        this.searchText = ''
      }
    },
    multiSelected () {
    },
    customerList() {
      this.cloneCustomerList = cloneDeep(this.customerList)
      this.onChangeData()
      this.param.customerDepts = this.customerList
      this.getBillChartData(this.param)
      this.getProductChartData(this.param)
      this.getBeforeMonthUsedAmount(this.param)
      this.selectBeforeMonthContractTop(this.param)
      this.selectBeforeMonthProductsTop(this.param)
      this.selectServiceRequestStatus(this.param)
      this.$showSpinner(false)
    },
    productsMonth() {
      let payload = this.param
      payload.endMonth = moment(new Date()).format("YYYYMM")
      payload.startMonth = moment(payload.endMonth).add(this.productsMonth, "M").format("YYYYMM")
      this.getProductChartData(payload)
    },
    billMonth(){
      let payload = this.param
      payload.endMonth = moment(new Date()).format("YYYYMM")
      payload.startMonth = moment(payload.endMonth).add(this.billMonth, "M").format("YYYYMM")
      this.getBillChartData(payload)
    },
    filterCustomerList(value){

    }
  },
  mounted() {
    this.$showSpinner(true)
    this.userAuth = this.userInfo.auth
    this.showSelectEmployee = (this.userAuth == AUTH_GROUP.BespinAdmin || this.userAuth == AUTH_GROUP.BespinManager || this.userAuth == AUTH_GROUP.BespinBilling || this.userAuth == AUTH_GROUP.BespinMiddleManager)
    this.param.endMonth = moment(new Date()).format("YYYYMM")
    this.param.startMonth = moment(this.param.endMonth).add("-5", "M").format("YYYYMM")
    let today = moment(new Date()).format("YYYY-MM-DD")
    this.param.startDate = today
    this.param.endDate = today

    if(this.userInfo.auth === AUTH_GROUP.AccountManager){
      this.param.customerDepts = [{ customerCode : this.userInfo.customerCode, deptCode : this.userInfo.customerDeptCode, checked : true }]
    }else if(this.userInfo.auth === AUTH_GROUP.BespinSales){
      this.cloneCustomerList = cloneDeep(this.customerList)
      this.param.customerDepts = this.cloneCustomerList
      this.param.empNo = this.userInfo.empNo
      this.getCustomers(this.userInfo.userEmail)
    }else{

      if(this.userInfo.auth === AUTH_GROUP.BespinMiddleManager){
        this.cloneCustomerList = cloneDeep(this.salesList)
        this.param.customerDepts = this.cloneCustomerList
      }
      this.getCustomersSales()
      this.selectSaleUser = this.salesList[0]
    }
    this.$showSpinner(false)
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/home/components/SelectTop.vue